import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../services/layout.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { IMenuItem } from '../interfaces/layout.interface';

@Component({
    standalone: false,
    selector: '[app-menuitem]',
    templateUrl: './menuitem.component.html',
    styleUrls: ['./menuitem.component.scss'],
    animations: [
        trigger('children', [
            state('collapsed', style({ height: '0' })),
            state('expanded', style({ height: '*' })),
            transition('collapsed <=> expanded', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
        ]),
    ],
})
export class MenuitemComponent implements OnInit, OnDestroy {
    subscriptions: Subscription[] = [];
    @Input() item!: IMenuItem;
    @Input() index!: number;
    @Input() @HostBinding('class.layout-root-menuitem') root!: boolean;
    @Input() parentKey!: string;
    active = false;

    key = '';

    constructor(
        public router: Router,
        private layoutService: LayoutService,
    ) {
        this.subscriptions.push(
            this.layoutService.menuSource$.subscribe((value) => {
                Promise.resolve(null).then(() => {
                    if (value.routeEvent) {
                        this.active =
                            value.key === this.key || value.key.startsWith(this.key + '-')
                                ? true
                                : false;
                    } else {
                        if (value.key !== this.key && !value.key.startsWith(this.key + '-')) {
                            this.active = false;
                        }
                    }
                });
            }),
            this.layoutService.resetSource$.subscribe(() => {
                this.active = false;
            }),
            this.router.events
                .pipe(filter((event) => event instanceof NavigationEnd))
                .subscribe(() => {
                    if (this.item.routerLink) {
                        this.updateActiveStateFromRoute();
                    }
                }),
        );
    }

    ngOnInit(): void {
        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);

        if (this.item.routerLink) {
            this.updateActiveStateFromRoute();
        }
    }

    updateActiveStateFromRoute() {
        const activeRoute = this.router.isActive(this.item.routerLink[0], {
            paths: 'exact',
            queryParams: 'ignored',
            matrixParams: 'ignored',
            fragment: 'ignored',
        });

        if (activeRoute) {
            this.layoutService.onMenuStateChange({ key: this.key, routeEvent: true });
        }
    }

    itemClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.item.disabled) {
            return;
        }
        if (this.item.command) {
            this.item.command({ originalEvent: event, item: this.item });
        }
        if (this.item.items) {
            this.active = !this.active;
        }
        this.layoutService.onMenuStateChange({ key: this.key });
    }

    get submenuAnimation() {
        return this.root ? 'expanded' : this.active ? 'expanded' : 'collapsed';
    }

    @HostBinding('class.active-menuitem')
    get activeClass() {
        return this.active && !this.root;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }
}
